import React from 'react';
import PropTypes from 'prop-types';
import {Notebook} from '../Notebook';
import {Modal} from '@learningblocks/exp-components';
import {LevelSelector} from '@learningblocks/storybook-components';
import {ProtocolView} from '../ProtocolView';
import {Modal as SceneModal} from "../ProtocolScene/Dialogs/modal";

import BackgroundImage from "./img/Background.svg"

export class MainScene extends React.Component {

  componentWillMount(){
    this.props.setLevel({
      id: 3,
      label: 'Level three',
      description: 'For those well acquainted with the technique, emphasizing exploration of new skills and topics.',
      value: 'levelThree',
    })
  }

  render() {
    return (
      <div style={{
        backgroundImage: `url(${BackgroundImage})`,
        width: "100vw",
        height: "100vh"
      }}>
        <Modal
          isOpen={this.props.showLevelModal}
          contentLabel='Select Simulation Level'
          className='Modal sm'
          size='sm'>
          <LevelSelector
            simulationLevels={[
              // {
              //   id: 1,
              //   label: 'Level one',
              //   description: 'Students load and run a gel with an unknown sample and positive and negative controls. Then students interpret the bands on the gel to determine genotypes.',
              //   value: 'levelOne',
              // },
              // {
              //   id: 2,
              //   label: 'Level two',
              //   description: 'Students load a gel with an unknown sample and positive and negative controls, then interpret the results of the gel PLUS gels from their entire "class". Students interpret the bands on the gel to determine genotypes, calculate genotype frequencies, and learn about human genetic variation within a population.',
              //   value: 'levelTwo',
              // }
              // ,
              {
                id: 3,
                label: 'Level three',
                description: 'For those well acquainted with the technique, emphasizing exploration of new skills and topics.',
                value: 'levelThree',
              },
            ]}
            defaultSelected={3}
            setLevel={this.props.setLevel}
          />
        </Modal>
        {this.props.levelSelected && (
          <>
          <Notebook />
          <ProtocolView />
          <SceneModal />
          </>
        )}
      </div>
    );
  }
}

MainScene.propTypes = {
  showLevelModal: PropTypes.bool.isRequired,
  setLevel: PropTypes.func.isRequired,
};
